export const queryKeys = {
  FLAT_FILTER_TABLE: 'FLAT_FILTER_TABLE'
};
